export class AuthorizeState {
  public id: number = 0;
  public authed: boolean = false;
}
